export interface PurchaseOrderLineQuickCreate {
  purchaseOrderHeaderId: string;
  productId: string;
  quantity: number;
  price: number;
  nextDayDelivery: boolean;
  deliveryDate: Date;
  supplierLineRef: string;
  supplierReference: string;
  productKey: string;
  productDescription: string;
  purchaseContractHeaderId: string;
  purchaseContractLineId: string;
  currencyCode: string;
  clearQuickCreate: boolean;
  nearestEighth: boolean;
  noOfItems: number;
  showNoOfItemsOnPurchaseOrder: boolean;
  workOutQuantityFromItemsPurchaseOrder: boolean;
  fabricProcessingFabricId: string;
  fabricSpecComments: string;
}
